
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http
        .get(`commercial-invoices/${this.$route.query.id}`)
        .then(res => {
          this.invoice = res.data
          this.invoice.items = this.invoice.items.map(i => {
            return {
              ...i
            }
          })
          this.invoice.packages = this.invoice.packages.map(p => {
            let item = this.invoice.items.find(i => i.seq === p.itemSeq)
            return {
              ...p,
              item: item
            }
          })
        })
        .then(() => {
          this.$refs.packingItemList.initNGVData()
        })
    },
    save() {
      if (this.canSave()) {
        this.$http
          .put(`commercial-invoices/${this.$route.query.id}`, {
            ...this.invoice,
            packages: this.invoice.packages.map(i => {
              if (i.item) {
                i.currencyCode =
                  i.item.currencyCode || this.invoice.currencyCode
                i.unitPrice = i.item.unitPrice
              }
              return i
            })
          })
          .then(() => this.$message('', this.$t('app.messages.saveSuccess'))) //'完了しました'
          .catch(res => {
            this.showError(res)
          })
      }
    }
  }
}
</script>
